import gsap from 'gsap';
import BaseComponent from './BaseComponent';

export default class GalleryItem extends BaseComponent {
	constructor(element) {
		super();

		this.el = element;

		this.trigger = this.el.querySelector('[data-gallery-trigger]');

		this.image = this.trigger;

		this.meta = this.el.querySelector('[data-gallery-meta]');
		this.payloadContainer = this.el.querySelector('[data-item-payload]');

		this.speed = parseFloat(this.el.dataset.speed) || 0.03;

		this.parallaxY = gsap.quickTo(this.image, 'y', {
			duration: 0.8,
			ease: 'power1.out',
		});

		this.initHover();
		this.initClick();
	}

	initClick() {
		if (!this.trigger || !this.payloadContainer) return;

		this.addListener(this.trigger, 'click', () => {
			const payload = {
				imageSrc: this.payloadContainer
					.querySelector('[data-payload-large-src]')
					.getAttribute('data-payload-large-src'),
				title: this.payloadContainer.querySelector('[data-payload-title]').textContent,
				school: this.payloadContainer.querySelector('[data-payload-school]').textContent,
				province: this.payloadContainer.querySelector('[data-payload-province]').textContent,
				text: this.payloadContainer.querySelector('[data-payload-text]').innerHTML,
				students: this.payloadContainer.querySelector('[data-payload-students]').textContent,
			};

			this.trigger.dispatchEvent(
				new CustomEvent('galleryItemOpen', {
					bubbles: true,
					detail: payload,
				})
			);
		});
	}

	initHover() {
		if (window.innerWidth < 992) return;

		gsap.set(this.meta, {
			y: -30,
			opacity: 0,
		});

		this.addListener(this.image, 'mouseenter', () => {
			gsap.to(this.image, {
				scale: 1.06,
				duration: 0.6,
				ease: 'power3.out',
			});

			gsap.to(this.meta, {
				y: 0,
				opacity: 1,
				duration: 0.5,
				ease: 'power3.out',
			});
		});

		this.addListener(this.image, 'mouseleave', () => {
			gsap.to(this.image, {
				scale: 1,
				duration: 0.6,
				ease: 'power3.out',
			});

			gsap.to(this.meta, {
				y: -30,
				opacity: 0,
				duration: 0.4,
				ease: 'power2.out',
			});
		});
	}

	update(scrollY) {
		const rect = this.el.getBoundingClientRect();

		if (rect.bottom < 0 || rect.top > window.innerHeight) {
			return;
		}

		const offset = (rect.top - window.innerHeight / 2) * this.speed;

		this.parallaxY(offset);
	}

	destroy() {
		super.destroy();
	}
}
